import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators, Form } from "@angular/forms";
import { DoctypeService } from "src/app/doctype-section/doctype-service/doctype.service";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { DoctorsService } from "src/app/doctor-section/doctor-service/doctors.service";
import { Router, ActivatedRoute } from "@angular/router";
import { take } from "rxjs/operators";
import { MessageService, SelectItem } from "primeng/api";
import { HosdocService } from "../../hosdoc-service/hosdoc.service";

@Component({
  selector: "app-hospitaldocreg",
  templateUrl: "./hospitaldocreg.component.html",
  styleUrls: ["./hospitaldocreg.component.css"],
  providers: [MessageService],
})
export class HospitaldocregComponent implements OnInit {
  count = 1;
  rgForm: FormGroup;
  piForm: FormGroup;
  di: Form;
  CouncilArray = [];

  ci: Form;
  doctorTypeAray = [];
  degrees: SelectItem[];
  clinicDays: SelectItem[];
  isDocType = false;
  countryArray = [];
  isCbDisabled = true;
  isSelectDefaultOption: boolean = false;
  hosId: any;
  token: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private docService: DoctorsService,
    private authService: AuthService,
    private router: Router,
    private doctypeService: DoctypeService,
    private hosDocService: HosdocService
  ) {}

  ngOnInit(): void {
    this.hosId = this.activatedRoute.snapshot.queryParams["id"];
    console.log(this.hosId);
    this.authService.authDataSubject.pipe(take(1)).subscribe((res) => {
      this.token = res._token;
    });
    this.degrees = [
      { label: "MBBS", value: { name: "MBBS" } },
      { label: "BDS", value: { name: "BDS" } },
      { label: "MD", value: { name: "MD" } },
      { label: "BSC Nursing", value: { name: "BSC Nursing" } },
      { label: "B.Pharmacy", value: { name: "B.Pharmacy" } },
    ];
    this.clinicDays = [
      { label: "Sunday", value: { name: "Sunday" } },
      { label: "Monday", value: { name: "Monday" } },
      { label: "Tuesday", value: { name: "Tuesday" } },
      { label: "Wednesday", value: { name: "Wednesday" } },
      { label: "Thursday", value: { name: "Thursday" } },
      { label: "Friday", value: { name: "Friday" } },

      { label: "Saturday", value: { name: "Saturday" } },
    ];

    this.getDoctorType();
    this.getMedicalCouncil();
    this.initRgForm();
  }
  onPageNext() {
    /*  const name = this.rgForm.value["name"];
    const doctorType = this.rgForm.value["doctorType"];
    const email = this.rgForm.value["email"];
    const password = this.rgForm.value["password"];
   const degree = this.rgForm.value["degree"];

    const line1 = this.rgForm.value["line1"];
    const city = this.rgForm.value["city"];
    const pincode = this.rgForm.value["pincode"];
    const state = this.rgForm.value["state"];

    const clinic = this.rgForm.value["clinic"]
    const phoneNo = this.rgForm.value["phoneNo"];*/
    if (this.count < 5) {
      this.count = this.count + 1;
    }
  }
  onPreviousPage() {
    if (this.count > 1) {
      this.count = this.count - 1;
    }
  }
  initRgForm() {
    this.rgForm = new FormGroup({
      name: new FormControl(null, Validators.required),
      doctorType: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.required, Validators.email]),
      password: new FormControl(null, Validators.required),
      degree: new FormControl(null, Validators.required),
      //  gender: new FormControl(null, Validators.required),

      line1: new FormControl(null, Validators.required),
      city: new FormControl(null, Validators.required),
      pincode: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      state: new FormControl(null, Validators.required),
      experience: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      memberCouncil: new FormControl(null, Validators.required),
      memberCouncilId: new FormControl(null, Validators.required),
      patientLimit: new FormControl(null, Validators.required),
      consFee: new FormControl(null, Validators.required),
      clinicDays: new FormControl(null, Validators.required),
      startTime: new FormControl(null,Validators.required),
      endTime: new FormControl(null,Validators.required),
      clinic: new FormControl(null, Validators.required),
      phoneNo: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        Validators.minLength(10),
      ]),
    });
  }

  getDoctorType() {
    this.doctypeService.getDocType("").subscribe((res) => {
      this.doctorTypeAray = res;
      this.isDocType = true;
    });
  }
  getMedicalCouncil() {
    this.docService.getCouncilCountry().subscribe((res) => {
      this.countryArray = res.council;
    });
  }
  onChangeCountry(con) {
    this.CouncilArray = [];
    this.isSelectDefaultOption = true;
    this.isCbDisabled = true;
    this.docService.getCouncilByCountry(con).subscribe((res) => {
      this.CouncilArray = res.council.councilName;
      this.isCbDisabled = false;
    });
  }
  onSubmit() {
    const name = this.rgForm.value["name"];
    const doctorType = this.rgForm.value["doctorType"];
    const email = this.rgForm.value["email"];
    const password = this.rgForm.value["password"];
    let degree = this.rgForm.value["degree"];

    const line1 = this.rgForm.value["line1"];
    const city = this.rgForm.value["city"];
    const pincode = this.rgForm.value["pincode"];
    const state = this.rgForm.value["state"];

    const phoneNo = this.rgForm.value["phoneNo"];
    const experience = this.rgForm.value["experience"];
    const memberCouncil = this.rgForm.value["memberCouncil"];
    const patientLimit = this.rgForm.value["patientLimit"];
    const memberCouncilId = this.rgForm.value["memberCouncilId"];
    const consFee = this.rgForm.value["consFee"];
    if (this.rgForm.value.clinicDays && this.rgForm.value.clinicDays.length > 0) {
      this.rgForm.value.clinicDays = this.rgForm.value.clinicDays.map((day) => {
        return day.name;
      });
    }
    const clinicDays = this.rgForm.value["clinicDays"];
    const startTime = this.rgForm.value["startTime"];
    const endTime = this.rgForm.value["endTime"];
    console.log(this.rgForm.valid);
    if (degree && degree.length > 0) {
      degree = degree.map((sin) => {
        return sin.name;
      });
    }

    this.hosDocService
      .RegisterHosDoctorToDatabase(
        name,
        consFee,
        endTime,
        startTime,
        clinicDays,
        doctorType,
        email,
        experience,
        degree,
        line1,
        city,
        pincode,
        state,
        memberCouncil,
        patientLimit,
        phoneNo,
        password,
        memberCouncilId,
        this.hosId,
        this.token
      )
      .subscribe((res) => {
        this.count = this.count + 1;
        this.router.navigate(["/auth"]);
      });
  }
}
